module.exports = __webpack_public_path__ + "img/close.adb6d750.svg";